import { render, staticRenderFns } from "./FieldCreate.vue?vue&type=template&id=237e5d4a&scoped=true&"
import script from "./FieldCreate.vue?vue&type=script&lang=js&"
export * from "./FieldCreate.vue?vue&type=script&lang=js&"
import style0 from "./FieldCreate.vue?vue&type=style&index=0&id=237e5d4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237e5d4a",
  null
  
)

export default component.exports